import { createSlice } from "@reduxjs/toolkit";
import {
  advWithAmpPost,
  getAdvertisementType,
} from "../../thunks/common-thunks/commonThunk";
import { message } from "antd";
const initialState = {
  isLoading: false,
  addStatus: "idle",
  addStatusMsg: null,
  advStatus: null,
  error: null,
  user: null,
};
export const advertisementSlice = createSlice({
  name: "advertisement",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get target audience type
    builder
      .addCase(getAdvertisementType.pending, (state) => {
        state.isLoading = true;
        state.addStatus = "loading";
        state.error = null;
        state.addStatusMsg = null;
      })
      .addCase(getAdvertisementType.fulfilled, (state, action) => {
        state.isLoading = false;
        state.addStatus = "success";
        state.adv_types = action.payload;
        state.error = null;
      })
      .addCase(getAdvertisementType.rejected, (state, action) => {
        state.isLoading = false;
        state.addStatus = "failed";
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // post adv with amp form
    builder
      .addCase(advWithAmpPost.pending, (state) => {
        state.isLoading = true;
        state.advStatus = "loading";
        state.error = null;
      })
      .addCase(advWithAmpPost.fulfilled, (state, action) => {
        state.isLoading = false;
        state.advStatus = "success";
        state.updateSubmitadv = action.payload;
        message.success(action.payload.message);
      })
      .addCase(advWithAmpPost.rejected, (state, action) => {
        state.isLoading = false;
        state.advStatus = "failed";
        state.error = action.error?.message || "Something went wrong";
        message.error("Something went wrong!");
      });
  },
});
export default advertisementSlice.reducer;
